import styled, { css } from 'styled-components';

export const FileUploaderListManagerStyled = styled.div`

  .label {
    line-height: 24px;
  }

  .ant-row-flex {
    margin-bottom: 1px !important;
  }

  .ant-list-item {
    a {
      flex: auto;
    }
  }

  .ant-list-item-action {
    margin-left: 8px;
  }

  .ant-empty.ant-empty-normal {
    margin: 0;
  }

  .filename {
    flex: 1;
    min-width: 0;
    max-height: 3em;
    overflow: hidden;
    color: #1890ff;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    cursor: pointer;
    user-select: none;
    outline: none;
  }

  .storage-link {
    color: #1890ff;
    text-decoration: none;
    cursor: pointer;
    background-color: transparent;
    outline: none;
    transition: color 0.3s;
  }
`;

export const UploadWithMenuItemStyled = css`
  .upload-with-menuitem > .ant-upload-select > .ant-upload {
    padding: 5px 12px; /* to expand clickable area */
    line-height: 32px;

    /* .anticon {
      min-width: 12px !important;
      margin-right: 8px !important;
      font-size: 12px !important;
      vertical-align: -0.1em !important;
    } */
  }
`;
